var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileMenuClose = function SvgMobileMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1000A",
    d: "m18.89 7.401-4.95 4.95L8.992 7.4l-1.65 1.65L12.292 14l-4.95 4.949 1.65 1.65 4.95-4.95 4.95 4.95 1.65-1.65L15.59 14l4.95-4.949z"
  })));
};
export { SvgMobileMenuClose as ReactComponent };